import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useJwt } from "react-jwt";
import { userEmailKey } from '../../constants/app-constant';
import { BRAND } from '../../services/appConfig';
import MyExpenseRequestPage from '../../pages/MyExpenseRequestPage';
import MyServiceRequestPage from '../../pages/ServiceRequest/MyServiceRequestPage';

//import AuthService from '../../services/utility/authenticationService';

function AppHeader({ isLoginExist, onToggleSidebar, sidebarExpanded }) {

  //const auth = AuthService.getAuthToken();
  let [showDrop, setShowDrop] = useState(false);
  const [userEmail, setUserEmail] = useState(sessionStorage.getItem('username') ?? null);
  const [role, setRole] = useState(sessionStorage.getItem('role'));
  //const { decodedToken } = useJwt(auth.token);
  const navigate = useNavigate();


  //useEffect(() => {
  //  if (decodedToken) {
  //    const email =
  //      decodedToken?.[userEmailKey];
  //    setUserEmail(email);
  //  }
  //}, [decodedToken]);

  const showLogoutDrop = () => {
   setShowDrop(!showDrop);
  }

  const logOut = () => {
   //AuthService.clearAuthDetail();
   setShowDrop(false);
   sessionStorage.removeItem('loginToken');
   sessionStorage.removeItem('cartItems');
   sessionStorage.removeItem('role');
   sessionStorage.removeItem('username');
   navigate('/login')
  }

  const changePassword = () => {
   setShowDrop(false);
   navigate('/changepassword');
  }

  const goToCheckout = () => {
    navigate('/checkout');
  }

  const MyRequest = () => {
    navigate('/MyRequest');
  }

    const MyExpenseRequestPage = () => {
        navigate('/MyExpenseRequest');
    }

    const MyServiceRequestPage = () => {
        navigate('/MyServiceRequest');
    }

    const MyMasterRequestPage = () => {
        navigate('/MyMasterRequest');
    }

    const ApprovalExpenseRequestPage = () => {
        navigate('/ExpenseApprovalList');
    }

    const ReportExpenseRequestPage = () => {
        navigate('/ExpenseReport');
    }    

  return (
    <>
      <header id="header-admin-wrap" className="header-admin-fixed">

        <div id="header-admin">
          <div className="container">

            <div className="header-left">
              {onToggleSidebar && (
                <button
                  type="button"
                  className="sidebar-toggle"
                  aria-label="Toggle navigation menu"
                  aria-controls="sidebar-admin-wraper"
                  aria-expanded={!!sidebarExpanded}
                  onClick={onToggleSidebar}
                >
                  <span className="feather-menu"></span>
                </button>
              )}
              <div className="my-account-logo">
                <img className="img-fluid" src={BRAND.logoUrl} alt={BRAND.name} />
              </div>
            </div>
              <div className="header-right">
                <ul className="header-widget-wrap">
                {/* <li className={`header-widget`} onClick={() => goToCheckout()}>
                    <div className="aon-admin-messange sf-toogle-btn">
                      <span className="feather-shopping-cart"></span>
                    </div>
                </li> */}
                  <li className={`header-widget ${showDrop && 'active'}`}>
                    <div className="aon-admin-messange sf-toogle-btn" onClick={() => showLogoutDrop(showDrop)}>
                      <span className="feather-user-pic">{userEmail?.charAt(0).toUpperCase()}</span>
                    </div>
                    <div className="ws-toggle-popup popup-tabs-wrap-section user-welcome-area">
                      <ul className="user-welcome-list">
                        <li><strong>Welcome, <span className="site-text-primary text-break">{userEmail}</span></strong></li>
                        <li onClick={goToCheckout}><a> Go To Cart</a></li>
                                          <li onClick={MyRequest}><a> My Quotation</a></li>
                                          <li onClick={MyExpenseRequestPage}><a> My Reimbursement</a></li>
                                          <li onClick={MyServiceRequestPage}><a> My Service Request</a></li>
                                          <li onClick={MyMasterRequestPage}><a> My Customer/Item Request</a></li>
                                          {(role === 'Admin' || role === 'Manager') && <li onClick={ApprovalExpenseRequestPage}><a> Reimbursement Approval</a></li>}
                                          {(role === 'Admin' || role === 'Manager') && <li onClick={ReportExpenseRequestPage}><a> Reimbursement Report</a></li>}
                        <li onClick={changePassword}><a>Change Password</a></li>
                        <li onClick={logOut}><a><i className="feather-log-out"></i> Log Out</a></li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </div>

            {/*{isLoginExist && (*/}
            {/*  <div className="header-right">*/}
            {/*    <ul className="header-widget-wrap">*/}
            {/*      <li className={`header-widget ${showDrop && 'active'}`}>*/}
            {/*        <div className="aon-admin-messange sf-toogle-btn" onClick={() => showLogoutDrop(showDrop)}>*/}
            {/*          <span className="feather-user-pic">{userEmail.charAt(0).toUpperCase()}</span>*/}
            {/*        </div>*/}
            {/*        <div className="ws-toggle-popup popup-tabs-wrap-section user-welcome-area">*/}
            {/*          <ul className="user-welcome-list">*/}
            {/*            <li><strong>Welcome , <span className="site-text-primary text-break">{userEmail}</span></strong></li>*/}
            {/*            <li onClick={changePassword}><a><img className="img-fluid" src={require('../../assets/images/icons/password.png')} alt="certification" /> Change Password</a></li>*/}
            {/*            <li onClick={logOut}><a><i className="feather-log-out"></i> Log Out</a></li>*/}
            {/*          </ul>*/}
            {/*        </div>*/}
            {/*      </li>*/}
            {/*    </ul>*/}
            {/*  </div>*/}
            {/*)}*/}


          </div>
        </div>
      </header >
    </>
  );
}

export default AppHeader;